import React from 'react'
import PropTypes from 'prop-types'

import QuestStatus from './QuestStatus'

const QuestStatusSelectValue = props => (
  <div className="Select-value" title={props.value.title}>
    <span className="Select-value-label">
      <QuestStatus status={props.value.className} />
    </span>
  </div>
)

QuestStatusSelectValue.propTypes = {
  value: PropTypes.object
}

export default QuestStatusSelectValue



// WEBPACK FOOTER //
// ./src/components/mini/QuestStatusSelectValue.js